<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">
            {{ this.currentView }}
          </h2>
          <div class="section__buttons">
            <button
              class="btn add"
              data-bs-toggle="modal"
              data-bs-target="#addReviewModal"
            >
              <i class="fas fa-plus ms-1"></i>
              إضافة ملف جديد
            </button>

            <!-- Add Modal Start -->
            <div
              class="modal fade"
              id="addReviewModal"
              tabindex="-1"
              aria-labelledby="addReviewModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">أضافة ملف</h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      @click="this.clearData()"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form id="addReview" @submit.prevent="addNewReview($event)">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="fileTitle">العنوان</label>
                            <input
                              type="text"
                              class="form-control mt-2"
                              id="fileTitle"
                              placeholder="العنوان"
                              v-model="review.title"
                              required
                            />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label for="reviewStatus">حالة الملف</label>
                            <select
                              class="form-select form-control mt-2"
                              aria-label="Default select "
                              v-model="review.status"
                            >
                              <option selected disabled value="">
                                اختار حالة الملف
                              </option>
                              <option :value="0">حفظ داخل مسودة</option>
                              <option :value="1">نشر</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <label for="reviewImage">صورة الملف</label>
                            <UploadImages
                              class="form-control mt-2"
                              @changed="handleImages"
                              id="questionImage"
                              :max="1"
                              maxError="يمكنك رفع صورة واحدة لكل سوال"
                              fileError="لا يمكن رفع ملفات غير الصور"
                            />
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group files">
                            <label for="reviewFile">الملف</label>
                            <!-- Custom Input File -->
                            <div
                              class="dragDrop"
                              @dragover="onDropOver($event)"
                              @dragleave="onDropLeave($event)"
                            >
                              <div
                                v-if="this.file == null"
                                class="dragDrop__input"
                              >
                                <div class="dragDrop__input__icon">
                                  <i
                                    class="fa fa-upload icon"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </div>
                              <div v-else class="dragDrop__file">
                                <div class="dragDrop__file__icon">
                                  <i
                                    class="fa fa-file icon"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                                <div class="dragDrop__file__text">
                                  <span>{{ this.file.name }}</span>
                                </div>
                              </div>
                              <input
                                type="file"
                                id="chooseFiles"
                                placeholder="أضف الملف"
                                required
                                @change="onFileSelect($event)"
                                accept="application/pdf"
                                ref="reviewFileInput"
                              />
                            </div>
                            <!-- Custom Input File -->
                          </div>
                        </div>
                        <div class="col-12">
                          <!-- Add Categories Select -->
                          <div class="categories__select">
                            <div
                              class="categories__select__data"
                              v-show="this.categories.length > 0"
                            >
                              <div class="row">
                                <div class="col-12 col-md-6">
                                  <div class="form-group">
                                    <label>التصنيف</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      id="mainCategory"
                                      @change="onSelectMainCategory($event)"
                                    >
                                      <option selected disabled :value="0">
                                        اختار التصنيف
                                      </option>
                                      <option
                                        v-for="category in this.Maincategories"
                                        :key="category.category_id"
                                        :value="category.title"
                                      >
                                        {{ category.title }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                                <Transition name="scale" mode="out-in">
                                  <div class="col-12 col-md-6">
                                    <div
                                      class="form-group"
                                      v-if="this.subSelect.length > 0"
                                    >
                                      <label>تصنيف فرعى</label>
                                      <select
                                        class="form-select form-control mt-2"
                                        aria-label="Default select "
                                        id="subCategory"
                                        required
                                        @change="onSelectSubCategory($event)"
                                      >
                                        <option selected disabled :value="0">
                                          اختار التصنيف
                                        </option>
                                        <option
                                          v-for="category in this.subSelect"
                                          :key="category.category_id"
                                          :value="category.title"
                                        >
                                          {{ category.title }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </Transition>
                                <Transition name="scale" mode="out-in">
                                  <div class="col-12 col-md-6">
                                    <div
                                      class="form-group"
                                      v-if="this.subSubSelect.length > 0"
                                    >
                                      <label>تصنيف فرعى</label>
                                      <select
                                        class="form-select form-control mt-2"
                                        aria-label="Default select "
                                        @change="onSelectSubSubCategory($event)"
                                      >
                                        <option selected disabled value="">
                                          اختار التصنيف
                                        </option>
                                        <option
                                          v-for="category in this.subSubSelect"
                                          :key="category.category_id"
                                          :value="category.title"
                                        >
                                          {{ category.title }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </Transition>

                                <Transition name="scale" mode="out-in">
                                  <div class="col-12 col-md-6">
                                    <div
                                      class="form-group"
                                      v-if="this.subSubSubSelect.length > 0"
                                    >
                                      <label>تصنيف فرعى</label>
                                      <select
                                        class="form-select form-control mt-2"
                                        aria-label="Default select "
                                        @change="
                                          onSelectSubSubSubCategory($event)
                                        "
                                      >
                                        <option selected disabled value="">
                                          اختار التصنيف
                                        </option>
                                        <option
                                          v-for="category in this
                                            .subSubSubSelect"
                                          :key="category.category_id"
                                          :value="category.title"
                                        >
                                          {{ category.title }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </Transition>
                              </div>
                            </div>

                            <div
                              v-show="this.categories.length == 0"
                              class="categories__select__noData pt-3"
                            >
                              <p>اختار التصنيف:</p>
                              <h6 class="text-center pb-3">
                                لا يوجد تصنيفات حتى الآن
                              </h6>
                            </div>
                          </div>
                          <!-- Add Categories Select -->
                        </div>

                        <div class="col-12">
                          <div class="form-group text-start mt-4">
                            <button
                              type="submit"
                              :disabled="this.isUploadLoading"
                              class="btn add w-100"
                            >
                              <div
                                class="spinner-border text-dark"
                                v-if="this.isUploadLoading"
                                role="status"
                              >
                                <span class="visually-hidden">Loading...</span>
                              </div>

                              <span v-if="!this.isUploadLoading"> أضافة</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Modal End -->
            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
            <!-- Filter -->
            <button
              class="btn me-2 add"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <i class="fas fa-filter ms-1"></i>
              فلتر
            </button>
            <div
              class="modal fade"
              tabindex="-1"
              id="filterModal"
              aria-labelledby="filterModalLabel"
              data-bs-backdrop="static"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <form @submit.prevent="filteredSelectData($event)">
                    <div class="modal-header">
                      <h5 class="modal-title">اعادة تصنيف</h5>
                      <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div class="modal-body">
                      <!-- Add Categories Select -->
                      <div class="categories__select">
                        <div
                          class="categories__select__data"
                          v-show="this.categories.length > 0"
                        >
                          <div class="form-group">
                            <label>التصنيف</label>
                            <select
                              class="form-select form-control mt-2"
                              aria-label="Default select "
                              @change="onSelectFilterMainCategory($event)"
                            >
                              <option selected disabled value="">
                                اختار التصنيف
                              </option>
                              <option
                                v-for="category in this.Maincategories"
                                :key="category.category_id"
                                :value="category.title"
                              >
                                {{ category.title }}
                              </option>
                            </select>
                          </div>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subFilterSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subCategory"
                                @change="onSelectFilterSubCategory($event)"
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subFilterSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSubFilterSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subSubCategory"
                                @change="onSelectFilterSubSubCategory($event)"
                              >
                                <option selected disabled value="">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubFilterSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                          <Transition name="scale" mode="out-in">
                            <div
                              class="form-group"
                              v-if="this.subSubSubFilterSelect.length > 0"
                            >
                              <label>تصنيف فرعى</label>
                              <select
                                class="form-select form-control mt-2"
                                aria-label="Default select "
                                id="subSubSubCategory"
                                @change="
                                  onSelectFilterSubSubSubCategory($event)
                                "
                              >
                                <option selected disabled :value="0">
                                  اختار التصنيف
                                </option>
                                <option
                                  v-for="category in this.subSubSubFilterSelect"
                                  :key="category.category_id"
                                  :value="category.title"
                                >
                                  {{ category.title }}
                                </option>
                              </select>
                            </div>
                          </Transition>
                        </div>
                        <div
                          v-show="this.categories.length == 0"
                          class="categories__select__noData pt-3"
                        >
                          <p>اختار التصنيف:</p>
                          <h6 class="text-center pb-3">
                            لا يوجد تصنيفات حتى الآن
                          </h6>
                        </div>
                      </div>
                      <!-- Add Categories Select -->
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn delete"
                        data-bs-dismiss="modal"
                        @click="removeFiltered()"
                      >
                        اعادة تعيين
                      </button>
                      <button type="submit" class="btn add">تنفيذ</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table v-show="this.reviews.length > 0" class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">الرقم</th>
                  <th style="width: 30%" scope="col">عنوان ملف</th>
                  <th scope="col">حجم الملف</th>
                  <th scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(review, index) in this.reviews" :key="index">
                  <th scope="row">{{ index + 1 }}</th>

                  <td>{{ review.title }}</td>
                  <td class="dir-left">
                    {{ (review.size / 1024).toFixed(1) }} KB
                  </td>
                  <td class="controls">
                    <a class="btn view" :href="review.url" target="_blank">
                      <i class="fas fa-folder ms-1"></i>
                      عرض
                    </a>

                    <button
                      class="btn me-2 edit"
                      data-bs-toggle="modal"
                      data-bs-target="#editSelectreviewModal"
                      @click="this.viewSelectedFile(review)"
                    >
                      <i class="fas fa-edit ms-2"></i>
                      تعديل
                    </button>
                    <div
                      class="modal fade"
                      tabindex="-1"
                      id="editSelectreviewModal"
                      aria-labelledby="editSelectreviewModalLabel"
                      data-bs-backdrop="static"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-body text-end">
                            <div class="text-start">
                              <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>

                            <form
                              id="addInfograph"
                              @submit.prevent="updateSelectedReview($event)"
                            >
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="fileTitle">العنوان</label>
                                    <input
                                      type="text"
                                      class="form-control mt-2"
                                      id="fileTitle"
                                      placeholder="العنوان"
                                      v-model="updateReview.title"
                                      required
                                    />
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="reviewStatus">حالة الملف</label>
                                    <select
                                      class="form-select form-control mt-2"
                                      aria-label="Default select "
                                      v-model="updateReview.status"
                                    >
                                      <option selected disabled value="">
                                        اختار حالة الملف
                                      </option>
                                      <option :value="0">حفظ داخل مسودة</option>
                                      <option :value="1">نشر</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <div class="form-group">
                                    <label for="reviewImage">صورة الملف</label>
                                    <UploadImages
                                      class="form-control mt-2"
                                      @changed="handleImages"
                                      id="questionImage"
                                      :max="1"
                                      maxError="يمكنك رفع صورة واحدة لكل سوال"
                                      fileError="لا يمكن رفع ملفات غير الصور"
                                    />
                                  </div>
                                </div>

                                <div class="col-6">
                                  <div class="form-group">
                                    <label for="reviewImage">صورة الملف</label>
                                    <div
                                      class="img-container mt-2"
                                      v-if="updateReview.image_url"
                                    >
                                      <img
                                        :src="updateReview.image_url"
                                        class="img-fluid"
                                        alt="file image"
                                      />
                                    </div>
                                    <div class="img__container mt-2" v-else>
                                      <span>لا توجد صورة</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group files">
                                    <label for="reviewFile">الملف</label>
                                    <!-- Custom Input File -->
                                    <div
                                      class="dragDrop"
                                      @dragover="onDropOver($event)"
                                      @dragleave="onDropLeave($event)"
                                    >
                                      <div
                                        v-if="this.file == null"
                                        class="dragDrop__input"
                                      >
                                        <div class="dragDrop__input__icon">
                                          <i
                                            class="fa fa-upload icon"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                      </div>
                                      <div v-else class="dragDrop__file">
                                        <div class="dragDrop__file__icon">
                                          <i
                                            class="fa fa-file icon"
                                            aria-hidden="true"
                                          ></i>
                                        </div>
                                        <div class="dragDrop__file__text">
                                          <span>{{ this.file.name }}</span>
                                        </div>
                                      </div>
                                      <input
                                        type="file"
                                        id="chooseFiles"
                                        placeholder="أضف الملف"
                                        @change="onFileSelect($event)"
                                        accept="application/pdf"
                                        ref="reviewFileInput"
                                      />
                                    </div>
                                    <!-- Custom Input File -->
                                  </div>
                                </div>
                                <div class="col-12">
                                  <!-- Edit Categories Select -->
                                  <div class="categories__select">
                                    <div
                                      class="categories__select__data"
                                      v-show="this.categories.length > 0"
                                    >
                                      <div class="row">
                                        <div class="col-lg-6">
                                          <div class="form-group">
                                            <label>تحديث التصنيف</label>
                                            <select
                                              class="
                                                form-select form-control
                                                mt-2
                                              "
                                              aria-label="Default select "
                                              @change="
                                                onSelectMainCategory($event)
                                              "
                                            >
                                              <option
                                                selected
                                                disabled
                                                :value="0"
                                              >
                                                اختار التصنيف
                                              </option>
                                              <option
                                                v-for="category in this
                                                  .Maincategories"
                                                :key="category.category_id"
                                                :value="category.title"
                                              >
                                                {{ category.title }}
                                              </option>
                                            </select>
                                          </div>
                                          <Transition
                                            name="scale"
                                            mode="out-in"
                                          >
                                            <div
                                              class="form-group"
                                              v-if="this.subSelect.length > 0"
                                            >
                                              <label>تصنيف فرعى</label>
                                              <select
                                                class="
                                                  form-select form-control
                                                  mt-2
                                                "
                                                aria-label="Default select "
                                                required
                                                id="subCategory"
                                                @change="
                                                  onSelectSubCategory($event)
                                                "
                                              >
                                                <option
                                                  selected
                                                  disabled
                                                  value=""
                                                >
                                                  اختار التصنيف
                                                </option>
                                                <option
                                                  v-for="category in this
                                                    .subSelect"
                                                  :key="category.category_id"
                                                  :value="category.title"
                                                >
                                                  {{ category.title }}
                                                </option>
                                              </select>
                                            </div>
                                          </Transition>

                                          <Transition
                                            name="scale"
                                            mode="out-in"
                                          >
                                            <div
                                              class="form-group"
                                              v-if="
                                                this.subSubSelect.length > 0
                                              "
                                            >
                                              <label>تصنيف فرعى</label>
                                              <select
                                                class="
                                                  form-select form-control
                                                  mt-2
                                                "
                                                aria-label="Default select "
                                                @change="
                                                  onSelectSubSubCategory($event)
                                                "
                                              >
                                                <option
                                                  selected
                                                  disabled
                                                  value=""
                                                >
                                                  اختار التصنيف
                                                </option>
                                                <option
                                                  v-for="category in this
                                                    .subSubSelect"
                                                  :key="category.category_id"
                                                  :value="category.title"
                                                >
                                                  {{ category.title }}
                                                </option>
                                              </select>
                                            </div>
                                          </Transition>

                                          <Transition
                                            name="scale"
                                            mode="out-in"
                                          >
                                            <div
                                              class="form-group"
                                              v-if="
                                                this.subSubSubSelect.length > 0
                                              "
                                            >
                                              <label>تصنيف فرعى</label>
                                              <select
                                                class="
                                                  form-select form-control
                                                  mt-2
                                                "
                                                aria-label="Default select "
                                                @change="
                                                  onSelectSubSubSubCategory(
                                                    $event
                                                  )
                                                "
                                              >
                                                <option
                                                  selected
                                                  disabled
                                                  value=""
                                                >
                                                  اختار التصنيف
                                                </option>
                                                <option
                                                  v-for="category in this
                                                    .subSubSubSelect"
                                                  :key="category.category_id"
                                                  :value="category.title"
                                                >
                                                  {{ category.title }}
                                                </option>
                                              </select>
                                            </div>
                                          </Transition>
                                        </div>
                                        <div
                                          class="col-lg-6"
                                          v-if="
                                            this.updateReview
                                              .fullCategoriesInfo != null
                                          "
                                        >
                                          <div class="form-group">
                                            <label>التصنيف الحالى</label>

                                            <div class="categories">
                                              <ul class="pe-2">
                                                <li
                                                  v-for="category in this
                                                    .updateReview
                                                    .fullCategoriesInfo"
                                                  :key="category.category_id"
                                                >
                                                  - {{ category.title }}
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      v-show="this.categories.length == 0"
                                      class="categories__select__noData pt-3"
                                    >
                                      <p>اختار التصنيف:</p>
                                      <h6 class="text-center pb-3">
                                        لا يوجد تصنيفات حتى الآن
                                      </h6>
                                    </div>
                                  </div>
                                  <!-- Edit Categories Select -->
                                </div>
                                <div class="col-12">
                                  <div class="form-group text-start mt-4">
                                    <button type="submit" class="btn w-100 add">
                                      تعديل
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      class="btn me-2 delete"
                      @click="this.deleteSelectedReview(review)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.reviews) || this.reviews.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد مذكرات ومرجعات حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
// Upload Image
import UploadImages from "vue-upload-drop-images";
// Firebase Upload Component
import FirebaseUploadingFileVue from "@/components/FirebaseUploadingFile.vue";
// Toast to Show Message
import { useToast, TYPE } from "vue-toastification";
const toast = useToast();
// Delete from firebase Storage
import { deleteFileFromUrl } from "@/firebase/firebase_storage";

export default {
  data() {
    return {
      isUploadLoading: false,

      showPDF: null,
      // Get Categories has Main
      Maincategories: [],
      // Loop for Categories
      selectedCategory: null,
      selectedSubCategory: null,
      selectedSubSubCategory: null,
      selectedSubSubSubCategory: null,
      // Save Result loop Categories
      subSelect: [],
      subSubSelect: [],
      subSubSubSelect: [],

      // Update Review
      updateReview: {},
      // Loading
      isloading: false,
      firstLoad: "",
      // Current Page Name
      currentView: "المذكرات والمرجعات",
      // Reviews Data
      file: null,
      image_url: null,
      categories: [],
      reviews: [],
      review: {
        file_type: 2,
        status: 1,
        title: "",
        image_url: null,
        size: 0,
        url: "",
        categories: [],
        fullCategoriesInfo: [],
      },

      //
      imageUploaded: false,
      fileUploaded: false,
      //
      searchValue: "",

      // Filter
      selectedFiltrtCategory: null,
      selectedFiltrtSubCategory: null,
      selectedFiltrtSubSubCategory: null,
      selectedFiltrtSubSubSubCategory: null,

      subFilterSelect: [],
      subSubFilterSelect: [],
      subSubSubFilterSelect: [],
      subSubSubSubFilterSelect: [],

      filter: [],
    };
  },
  components: {
    UploadImages,
  },
  methods: {
    ...mapActions("reviewModule", [
      "fetchReviews",
      "addReview",
      "deleteReview",
      "updateReviewById",
      "getReviewById",
    ]),

    // Sort
    sortByCreateDate() {
      this.reviews.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.reviews.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------------//

    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.reviews = this.getReviews.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------
    // Get Categories
    ///// Get Main Category
    onSelectFilterMainCategory($event) {
      let title = $event.target.value;
      this.selectedFilterCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      // Reset Choose Sub Category
      this.subFilterSelect = [];
      this.subSubFilterSelect = [];
      this.subSubSubFilterSelect = [];
      this.filter = [];

      // Choose Sub Category
      if (this.selectedFilterCategory.sub_categories.length > 0) {
        this.subFilterSelect.push(
          ...this.selectedFilterCategory.sub_categories
        );
      }
      this.filter.push(this.selectedFilterCategory.category_id);
      document.getElementById("subCategory").value = 0;
    },
    ///// Get Sub Category
    onSelectFilterSubCategory($event) {
      let title = $event.target.value;
      this.selectedFilterSubCategory = this.subFilterSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubFilterSelect = [];
      this.subSubSubFilterSelect = [];

      this.filter.splice(1, 3);
      if (this.selectedFilterSubCategory.sub_categories.length > 0) {
        this.subSubFilterSelect.push(
          ...this.selectedFilterSubCategory.sub_categories
        );
      }
      this.filter.push(this.selectedFilterSubCategory.category_id);
      document.getElementById("subSubCategory").value = 0;
    },
    ///// Get Sub Sub Category
    onSelectFilterSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubCategory = this.subSubFilterSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSubFilterSelect = [];

      this.filter.splice(2, 1);
      if (this.selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubFilterSelect.push(
          ...this.selectedSubSubCategory.sub_categories
        );
      }
      this.filter.push(this.selectedSubSubCategory.category_id);
      document.getElementById("subSubSubCategory").value = 0;
    },
    onSelectFilterSubSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubSubCategory = this.subSubSubFilterSelect.filter(
        (item) => item.title === title
      )[0];
      this.filter.splice(3, 1);
      this.filter.push(this.selectedSubSubSubCategory.category_id);
      console.log(this.filter);
    },
    //-----------------------------------------------
    // Filter
    filteredSelectData(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      // console.log(this.filter);
      // this.filter.filter((item) => {
      //   this.reviews = this.getReviews.filter((element) =>
      //     element.categories.includes(item)
      //   );
      // });
      this.reviews = [];
      this.getReviews.forEach((review) => {
        if (this.filter.length == 1 && review.categories[0] == this.filter[0]) {
          this.reviews.push(review);
        } else if (
          this.filter.length == 2 &&
          review.categories[0] == this.filter[0] &&
          review.categories[1] == this.filter[1]
        ) {
          this.reviews.push(review);
        } else if (
          this.filter.length == 3 &&
          review.categories[0] == this.filter[0] &&
          review.categories[1] == this.filter[1] &&
          review.categories[2] == this.filter[2]
        ) {
          this.reviews.push(review);
        } else if (
          this.filter.length == 4 &&
          review.categories[0] == this.filter[0] &&
          review.categories[1] == this.filter[1] &&
          review.categories[2] == this.filter[2] &&
          review.categories[3] == this.filter[3]
        ) {
          this.reviews.push(review);
        }
      });

      closeButton.click();
    },

    removeFiltered() {
      this.reviews = this.getReviews;
      // this.filter = "";
      this.filter = [];
    },
    //-----------------------------------------------

    // Vuex Methods
    ///// Add Review
    async addNewReview(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      this.isUploadLoading = true;

      if (this.file !== null) {
        const content = {
          component: FirebaseUploadingFileVue,
          props: {
            title: "يتم رفع الملف الان",
            file: this.file,
            contentType: "application/pdf",
            collection: "Files",
            onFinished: (url) => {
              console.log(url);
              this.review.url = url ?? "";
              this.review.size = this.file.size;
              toast.dismiss(toastId);
              if (this.image_url !== null) {
                const content = {
                  component: FirebaseUploadingFileVue,
                  props: {
                    title: "يتم رفع صورة الملف الان",
                    file: this.image_url,
                    collection: "Images",
                    onFinished: (url) => {
                      console.log(url);
                      this.review.image_url = url ?? "";
                      toast.dismiss(toastId);
                      this.addReview(this.review);
                      closeButton.click();
                      this.clearAndShowSuccess("تم إضافة الملف بنجاح");
                      this.isUploadLoading = false;
                    },
                  },
                };
                const toastId = toast(content, {
                  icon: false,
                  hideProgressBar: true,
                  closeButton: false,
                  type: TYPE.INFO,
                  timeout: false,
                  toastClassName: "my-custom-toast-class",
                });
              } else {
                this.addReview(this.review);
                closeButton.click();
                this.clearAndShowSuccess("تم إضافة الملف بنجاح");
                this.isUploadLoading = false;
              }
            },
          },
        };
        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
          toastClassName: "my-custom-toast-class",
        });
      }
    },

    handleImages(files) {
      this.image_url = files[0];
    },

    ///// Update Review
    async updateSelectedReview(event) {
      let closeButton =
        event.target.parentNode.parentNode.firstChild.querySelector("button");
      if (this.file !== null) {
        deleteFileFromUrl(this.review.url);
        const content = {
          // Your component or JSX template
          component: FirebaseUploadingFileVue,

          // Props are just regular props, but these won't be reactive
          props: {
            title: "يتم رفع الملف الان",
            file: this.file,
            contentType: "application/pdf",
            collection: "Files",
            onFinished: (url) => {
              this.updateReview.url = url ?? "";
              this.updateReview.size = this.file.size;
              toast.dismiss(toastId);
              if (this.image_url !== null) {
                const content = {
                  component: FirebaseUploadingFileVue,
                  props: {
                    title: "يتم رفع صورة الملف الان",
                    file: this.image_url,
                    collection: "Images",
                    onFinished: (url) => {
                      console.log(url);
                      this.updateReview.image_url = url ?? "";
                      toast.dismiss(toastId);
                      this.updateReviewById(this.updateReview);
                      closeButton.click();
                      this.clearAndShowSuccess("تم تعديل الملف بنجاح");
                      this.compareUpdate();
                    },
                  },
                };
                const toastId = toast(content, {
                  icon: false,
                  hideProgressBar: true,
                  closeButton: false,
                  type: TYPE.INFO,
                  timeout: false,
                  toastClassName: "my-custom-toast-class",
                });
              } else {
                this.updateReviewById(this.updateReview);
                closeButton.click();
                this.clearAndShowSuccess("تم تعديل الملف بنجاح");
                this.compareUpdate();
              }
            },
          },
        };

        const toastId = toast(content, {
          icon: false,
          hideProgressBar: true,
          closeButton: false,
          type: TYPE.INFO,
          timeout: false,
        });
      } else {
        if (this.image_url !== null) {
          const content = {
            component: FirebaseUploadingFileVue,
            props: {
              title: "يتم رفع صورة الملف الان",
              file: this.image_url,
              collection: "Images",
              onFinished: (url) => {
                console.log(url);
                this.updateReview.image_url = url ?? "";
                toast.dismiss(toastId);
                this.updateReviewById(this.updateReview);
                closeButton.click();
                this.clearAndShowSuccess("تم تعديل الملف بنجاح");
                this.compareUpdate();
              },
            },
          };
          const toastId = toast(content, {
            icon: false,
            hideProgressBar: true,
            closeButton: false,
            type: TYPE.INFO,
            timeout: false,
            toastClassName: "my-custom-toast-class",
          });
        } else {
          await this.updateReviewById(this.updateReview);
          closeButton.click();
          this.clearAndShowSuccess("تم تعديل الملف بنجاح");
          this.compareUpdate();
        }
      }
    },

    compareUpdate() {
      this.reviews.forEach((review) => {
        if (review.review_id == this.updateReview.review_id) {
          review.title = this.updateReview.title;
          review.url = this.updateReview.url;
          review.image_url = this.updateReview.image_url;
          review.size = this.updateReview.size;
          review.categories = this.updateReview.categories;
        }
      });
    },
    ///// Delete Review
    deleteSelectedReview(review) {
      console.log("deleteReview", review);
      Swal.fire({
        text: "هل أنت متأكد من حذف هذه الملف؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف الملف بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteReview(review.review_id);
          deleteFileFromUrl(review.url);
        }
      });
    },
    //-----------------------------------------------------//
    // Get Categories
    ///// Get Main Category
    onSelectMainCategory($event) {
      let title = $event.target.value;
      this.selectedCategory = this.categories.filter(
        (item) => item.title === title
      )[0];
      // Reset Choose Sub Category
      this.subSelect = [];
      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.review.categories = [];
      this.review.fullCategoriesInfo = [];
      this.updateReview.categories = [];
      this.updateReview.fullCategoriesInfo = [];

      // Choose Sub Category
      if (this.selectedCategory.sub_categories.length > 0) {
        this.subSelect.push(...this.selectedCategory.sub_categories);
      }
      this.review.categories.push(this.selectedCategory.category_id);
      this.review.fullCategoriesInfo.push(this.selectedCategory);
      this.updateReview.categories.push(this.selectedCategory.category_id);
      this.updateReview.fullCategoriesInfo.push(this.selectedCategory);
      // console.log("subSelect", this.subSelect);
      console.log("Review", this.review);
      document.getElementById("subCategory").value = 0;
    },
    ///// Get Sub Category
    onSelectSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubCategory = this.subSelect.filter(
        (item) => item.title === title
      )[0];
      this.subSubSelect = [];
      this.subSubSubSelect = [];

      this.review.categories.splice(1, 3);
      this.review.fullCategoriesInfo.splice(1, 3);
      this.updateReview.categories.splice(1, 3);
      this.updateReview.fullCategoriesInfo.splice(1, 3);
      if (this.selectedSubCategory.sub_categories.length > 0) {
        this.subSubSelect.push(...this.selectedSubCategory.sub_categories);
      }
      this.review.categories.push(this.selectedSubCategory.category_id);
      this.review.fullCategoriesInfo.push(this.selectedSubCategory);
      this.updateReview.categories.push(this.selectedSubCategory.category_id);
      this.updateReview.fullCategoriesInfo.push(this.selectedSubCategory);
      console.log("subSubSelect review", this.review);
    },
    ///// Get Sub Sub Category
    onSelectSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubCategory = this.subSubSelect.filter(
        (item) => item.title === title
      )[0];
      // Delete if Change
      this.subSubSubSelect = [];
      this.review.categories.splice(2, 1);
      this.review.fullCategoriesInfo.splice(2, 1);
      this.updateReview.fullCategoriesInfo.splice(2, 1);
      this.updateReview.categories.splice(2, 1);
      // Add New Value
      if (this.selectedSubSubCategory.sub_categories.length > 0) {
        this.subSubSubSelect.push(
          ...this.selectedSubSubCategory.sub_categories
        );
      }
      this.review.categories.push(this.selectedSubSubCategory.category_id);
      this.review.fullCategoriesInfo.push(this.selectedSubSubCategory);
      this.updateReview.fullCategoriesInfo.push(this.selectedSubSubCategory);
      this.updateReview.categories.push(
        this.selectedSubSubCategory.category_id
      );
      console.log("subSubSelect review", this.review);
    },

    onSelectSubSubSubCategory($event) {
      let title = $event.target.value;
      this.selectedSubSubSubCategory = this.subSubSubSelect.filter(
        (item) => item.title === title
      )[0];
      // Delete if Change
      this.review.categories.splice(3, 1);
      this.review.fullCategoriesInfo.splice(3, 1);
      this.updateReview.fullCategoriesInfo.splice(3, 1);
      this.updateReview.categories.splice(3, 1);
      // Add New Value
      this.review.categories.push(this.selectedSubSubSubCategory.category_id);
      this.review.fullCategoriesInfo.push(this.selectedSubSubSubCategory);
      this.updateReview.fullCategoriesInfo.push(this.selectedSubSubSubCategory);
      this.updateReview.categories.push(
        this.selectedSubSubSubCategory.category_id
      );
      console.log("subSubSelect review", this.review);
    },
    //-----------------------------------------------------//
    // clear Data when close modal
    clearData() {
      let clearButton = document.querySelector(".clearButton");
      clearButton.click();
      this.file = null;
      this.image_url = null;
      document.getElementById("chooseFiles").value = "";
      document
        .getElementsByClassName("dragDrop")[0]
        .classList.remove("drop_zone");
      document.getElementById("categorySelect").value = 0;
      this.subSelect = [];
      this.subSubSelect = [];
      this.selectedCategory = [];
      this.selectedSubCategory = [];
      document.get;
      this.review = {
        file_type: 2,
        url: "",
        status: 1,
        categories: [],
      };
    },
    // On Upload Image
    seccussAdd(message) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },
    // Handle Add Review
    clearAndShowSuccess(message) {
      this.seccussAdd(message);
      this.clearData();
    },
    //-----------------------------------------------------//
    async viewSelectedFile(review) {
      this.updateReview = await this.getReviewById(review.review_id);
      console.log("Review", this.updateReview);
    },

    //-----------------------------------------------------//
    ///// Custom Input File
    // Drop Over Elemet area
    onDropOver($event) {
      let el = $event.currentTarget;
      el.classList.add("drop_zone");
    },
    // Drop Leave Elemet area
    onDropLeave($event) {
      let el = $event.currentTarget;
      el.classList.remove("drop_zone");
    },
    // When Select File
    onFileSelect(e) {
      this.file = e.target.files[0] || e.dataTransfer;
      // this.lessonImage = this.file;
      console.log(this.file);
    },

    //-----------------------------------------------------//
  },
  async created() {
    if (this.isFirstLoad) await this.fetchReviews();
    // get Main Categories
    this.Maincategories = this.getCategories.filter(
      (item) => item.main_category === true
    );
  },

  computed: {
    ...mapGetters("categoriesModule", ["getCategories"]),
    ...mapGetters("reviewModule", [
      "getReviews",
      "isLoading",
      "isFirstLoad",
      "getUpdateReview",
    ]),
  },
  mounted() {
    this.reviews = this.getReviews;
    this.categories = this.getCategories;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
    document.getElementById("mainCategory").value = 0;
  },
  watch: {
    getReviews() {
      this.reviews = this.getReviews;
    },
    getCategories() {
      this.categories = this.getCategories;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
  },
};
</script>
